export default __webpack_public_path__ + "static/Preview-30ea39d626cd9508efb70e41c505a8f4.jpg";